import React from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

const formatParagraph = paragraph =>
  paragraph
    .split('\n')
    .reduce((result, part, key) => [...result, <br key={key} />, part], [])
    .splice(1);

const formatDescription = description =>
  description
    .split('\n\n')
    .map((paragraph, key) => <p key={key}>{formatParagraph(paragraph)}</p>);

export default ({ description }) => {
  return (
    <div className={styles.container}>
      {description ? (
        formatDescription(description)
      ) : (
        <p>
          No description has been added for this item. Help out by adding one!
        </p>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/description/index.js